module.exports = __webpack_public_path__ + "static/redime-tus-puntos-3-b1a7c32b406edf1b115454bf59aee9f1.png";